import { render, staticRenderFns } from "./InvoiceView.vue?vue&type=template&id=a45358ca&scoped=true&"
import script from "./InvoiceView.vue?vue&type=script&lang=js&"
export * from "./InvoiceView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceView.vue?vue&type=style&index=0&id=a45358ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45358ca",
  null
  
)

export default component.exports